export default __webpack_public_path__ + "static/media/error.ce7d2b34.svg";